/**
 * Brazilian Portuguese (pt-BR) mappings for GamePredictionButton
 */

export const gamePredictionButtonPtBR = {
  "AI Prediction": "Previsão IA",
  "spin": "giro",
  "spins": "giros",
  "Use coins": "Usar moedas",
  "Reset soon": "Resetar em breve",
  "Soon": "Em breve"
};